export default "__VITE_ASSET__BCfuiFXQ__"